import _ from 'lodash';



export function getDollarString(dollars? : number | null): string {
  if (_.isNil(dollars)) {
    return '$ -';
  }

  if (dollars < 1000) {
    return `$${dollars.toFixed(0)}`; // Early return if unit label is not required (and fallback for invalid negative number)
  }

  const [base, exp] = dollars.toExponential().split('e');

  const baseNum = parseFloat(base);
  const power = parseInt(exp.slice(1));

  let thousands = Math.floor(power / 3);
  let unitLabel = '';

  if (thousands === 1) {
    unitLabel = 'K';
  } else if (thousands === 2) {
    unitLabel = 'M';
  } else if (thousands === 3) {
    unitLabel = 'B';
  } else {
    thousands = 4;
    unitLabel = 'T';
  }

  const finalPower = power - (thousands * 3);
  return `$${(baseNum * (10 ** finalPower)).toFixed(1)}${unitLabel}`;
}
